const confirmBookingRescheduleData = (state = null, action) => {
  if (action.type === "SET_CONFIRM_BOOKING_RESCHEDULE_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CONFIRM_BOOKING_RESCHEDULE_DATA": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default confirmBookingRescheduleData;
